import { SCREENSIZE } from 'app/lib/global-styles'

export default {
  get windowHeight() {
    return window.innerHeight
  },

  get windowWidth() {
    return window.innerWidth
  },

  get screenSize() {
    const windowInnerWidth = window.innerWidth

    switch (true) {
      case windowInnerWidth >= SCREENSIZE.LG:
        return 'lg'
      case windowInnerWidth >= SCREENSIZE.MD:
        return 'md'
      case windowInnerWidth >= SCREENSIZE.SM:
        return 'sm'
      case windowInnerWidth < SCREENSIZE.SM:
        return 'xs'
      default:
        return 'sm'
    }
  },
}
